<template functional>
  <i
    :class="[
      { 'el-icon-circle-check': props.rowValue === true },
      {
        'el-icon-circle-close':
          props.rowValue === null || props.rowValue === false
      }
    ]"
  ></i>
</template>

<script>
export default {
  name: "TasksFixedStatusColor",

  handleClick(props) {
    // Handle button click
    console.log("Button clicked!", props);
  }
};
</script>

<style scoped>
.el-icon-circle-check {
  color: green;
  font-size: 20px;
  font-weight: bold;
}
.el-icon-circle-close {
  color: red;
  font-size: 20px;
  font-weight: bold;
}
</style>
